import API from "serviceshift-ui/api-client";
import { authenticityToken } from "@/lib/helpers";

export default {
  async fetchLenderSettings(_, { lender }) {
    const response = await API.makeRequest("/lender_settings", {
      params: { lender }
    });
    return response.data;
  },

  async updateLenderSettings(_, settings) {
    const response = await API.makeRequest("/lender_settings", {
      method: "PUT",
      data: settings,
      headers: { "X-CSRF-Token": authenticityToken() }
    });
    return response.data;
  }
};
